import React, { Component } from 'react';

import Warning from '../../../../../components/Warning2';

import commonUtil from '../../../../../utils/commonUtil';

const channel = commonUtil.getChannel();

class HeaderFormRegister extends Component {
  render() {
    const props = this.props;
    const labels = props.labels;
    const user = props.user || '';
    const result = user.result || '';
    const firstName = result.firstName || '';
    const mode = (channel === 'web');
    const labelEditAdressTitle = commonUtil.getLabel(labels.createEventStep3, 'createEventStep3.editAddress.title');
    const labelEditAddAdressTitle = commonUtil.getLabel(labels.createEventStep3, 'createEventStep3.addAddress.title');
    const labelAddAddressMessage = commonUtil.getLabel(labels.createEventStep3, 'createEventStep3.addAddress.message');
    const labelDeliveryAddressTitle = commonUtil.getLabel(labels.createEventStep3, `createEventStep3.deliveryAddress.${mode ? '' : 'wap.'}title`);

    return (
      <div style={{ padding: mode ? '1px 25px 24px' : '32px 10px 24px' }}>
        {mode && (
          <React.Fragment>
            <div className="registerTitles">
              {
                this.editAddress
                ? <h2 className="registerGiftTitle registerGift-margin">
                  { `${firstName}, ${labelEditAdressTitle}` }
                </h2>
                :
                <h2 className="registerGiftTitle registerGift-margin">
                  { `${firstName}, ${labelEditAddAdressTitle}` }
                </h2>
              }
            </div>

            <p className="registerGiftText createAddressRegisterGift" style={{ marginBottom: 25 }}>{labelAddAddressMessage}</p>
          </React.Fragment>
        )}

        <Warning
          style={{ marginBottom: 25 }}
          ref={this.props.setRefWarning}
        />

        <div className="headerFormRegisterSub">
          <h3>{labelDeliveryAddressTitle}</h3>
          <p className="requiredInput"><sup>*</sup> Campos Obligatorios</p>
        </div>
      </div>
    );
  }
}

export default HeaderFormRegister;
